$.prototype.switchClass = function (removeClass, addClass) {
  $(this).removeClass(removeClass).addClass(addClass);
};
